import { render, staticRenderFns } from "./DashboardDisponibilidad.vue?vue&type=template&id=280fbf96&scoped=true&"
import script from "./DashboardDisponibilidad.vue?vue&type=script&lang=js&"
export * from "./DashboardDisponibilidad.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDisponibilidad.vue?vue&type=style&index=0&id=280fbf96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280fbf96",
  null
  
)

export default component.exports